import { render, staticRenderFns } from "./embed-code.vue?vue&type=template&id=7cf959e0&scoped=true&"
import script from "./embed-code.vue?vue&type=script&lang=js&"
export * from "./embed-code.vue?vue&type=script&lang=js&"
import style0 from "./embed-code.vue?vue&type=style&index=0&id=7cf959e0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7cf959e0",
  null
  
)

export default component.exports